import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const ParentNotifications = () => {
  const routes = all_routes;

  const [children] = useState([
    { id: "1", name: "Emma Johnson", grade: "10th", class: "10-A" },
    { id: "2", name: "James Johnson", grade: "8th", class: "8-B" },
  ]);

  const [selectedChildId, setSelectedChildId] = useState("1");
  const [filterType, setFilterType] = useState("all");

  const selectedChild = children.find((child) => child.id === selectedChildId);

  // Mock notifications data
  const notificationsData = [
    {
      id: "1",
      type: "academic",
      title: "Math Test Scheduled",
      message: "Mathematics test scheduled for tomorrow at 10:00 AM",
      timestamp: "2024-08-20 14:30",
      read: false,
      priority: "high",
      childId: "1",
      from: "Mrs. Smith",
    },
    {
      id: "2",
      type: "attendance",
      title: "Late Arrival",
      message: "Emma arrived 15 minutes late to school today",
      timestamp: "2024-08-20 09:15",
      read: true,
      priority: "medium",
      childId: "1",
      from: "School Admin",
    },
    {
      id: "3",
      type: "payment",
      title: "Fee Payment Due",
      message: "Monthly tuition fee payment is due in 3 days",
      timestamp: "2024-08-19 16:00",
      read: false,
      priority: "high",
      childId: "1",
      from: "Finance Office",
    },
    {
      id: "4",
      type: "event",
      title: "Parent-Teacher Meeting",
      message: "Scheduled for next Friday at 3:00 PM",
      timestamp: "2024-08-19 10:30",
      read: true,
      priority: "medium",
      childId: "1",
      from: "Principal Johnson",
    },
    {
      id: "5",
      type: "homework",
      title: "Assignment Submitted",
      message: "English essay has been submitted successfully",
      timestamp: "2024-08-18 15:45",
      read: true,
      priority: "low",
      childId: "1",
      from: "Mr. Brown",
    },
    {
      id: "6",
      type: "grades",
      title: "Grade Updated",
      message: "Science test grade has been updated: A-",
      timestamp: "2024-08-18 12:20",
      read: false,
      priority: "medium",
      childId: "1",
      from: "Dr. Wilson",
    },
  ];

  const getTypeIcon = (type: string) => {
    switch (type) {
      case "academic":
        return "ti-book";
      case "attendance":
        return "ti-calendar-check";
      case "payment":
        return "ti-credit-card";
      case "event":
        return "ti-calendar-event";
      case "homework":
        return "ti-clipboard-check";
      case "grades":
        return "ti-trophy";
      default:
        return "ti-bell";
    }
  };

  const getTypeColor = (type: string) => {
    switch (type) {
      case "academic":
        return "primary";
      case "attendance":
        return "warning";
      case "payment":
        return "danger";
      case "event":
        return "info";
      case "homework":
        return "success";
      case "grades":
        return "purple";
      default:
        return "secondary";
    }
  };

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case "high":
        return "danger";
      case "medium":
        return "warning";
      case "low":
        return "info";
      default:
        return "secondary";
    }
  };

  const filteredNotifications = notificationsData.filter((notification) => {
    const matchesChild = notification.childId === selectedChildId;
    const matchesType =
      filterType === "all" || notification.type === filterType;
    return matchesChild && matchesType;
  });

  const unreadCount = filteredNotifications.filter((n) => !n.read).length;
  const markAsRead = (id: string) => {
    // Mark notification as read
  };

  const markAllAsRead = () => {
    // Mark all notifications as read
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <div className="d-flex align-items-center">
                <Link
                  to={routes.parentMenu}
                  className="btn btn-outline-secondary btn-sm me-3"
                >
                  <i className="ti ti-arrow-left"></i>
                </Link>
                <div>
                  <h3 className="page-title mb-1">Notifications</h3>
                  <p className="text-muted mb-0">Past alerts & messages</p>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex gap-2">
                {children.length > 1 && (
                  <div className="dropdown">
                    <button
                      className="btn btn-outline-primary dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-user me-2"></i>
                      {selectedChild?.name}
                    </button>
                    <ul className="dropdown-menu">
                      {children.map((child) => (
                        <li key={child.id}>
                          <button
                            className={`dropdown-item ${
                              selectedChildId === child.id ? "active" : ""
                            }`}
                            onClick={() => setSelectedChildId(child.id)}
                          >
                            {child.name} - {child.grade} {child.class}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {unreadCount > 0 && (
                  <button className="btn btn-primary" onClick={markAllAsRead}>
                    Mark All Read
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Summary */}
          <div className="row mb-4">
            <div className="col-md-4">
              <div className="card bg-primary-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-primary mb-2">
                    <i className="ti ti-bell text-white fs-2"></i>
                  </div>
                  <h4 className="text-primary">
                    {filteredNotifications.length}
                  </h4>
                  <p className="mb-0">Total Notifications</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card bg-warning-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-warning mb-2">
                    <i className="ti ti-bell-ringing text-white fs-2"></i>
                  </div>
                  <h4 className="text-warning">{unreadCount}</h4>
                  <p className="mb-0">Unread</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card bg-danger-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-danger mb-2">
                    <i className="ti ti-alert-triangle text-white fs-2"></i>
                  </div>
                  <h4 className="text-danger">
                    {
                      filteredNotifications.filter((n) => n.priority === "high")
                        .length
                    }
                  </h4>
                  <p className="mb-0">High Priority</p>
                </div>
              </div>
            </div>
          </div>

          {/* Filters */}
          <div className="card mb-4">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Notifications</h5>
                <select
                  className="form-select w-auto"
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                >
                  <option value="all">All Types</option>
                  <option value="academic">Academic</option>
                  <option value="attendance">Attendance</option>
                  <option value="payment">Payment</option>
                  <option value="event">Events</option>
                  <option value="homework">Homework</option>
                  <option value="grades">Grades</option>
                </select>
              </div>
            </div>
            <div className="card-body">
              {filteredNotifications.length > 0 ? (
                filteredNotifications.map((notification) => (
                  <div
                    key={notification.id}
                    className={`card mb-3 border-start border-4 border-${getTypeColor(
                      notification.type
                    )} ${!notification.read ? "bg-light" : ""}`}
                  >
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="d-flex align-items-start">
                          <div
                            className={`avatar avatar-sm bg-${getTypeColor(
                              notification.type
                            )} me-3`}
                          >
                            <i
                              className={`ti ${getTypeIcon(
                                notification.type
                              )} text-white`}
                            ></i>
                          </div>
                          <div className="flex-fill">
                            <div className="d-flex align-items-center mb-1">
                              <h6 className="mb-0 me-2">
                                {notification.title}
                              </h6>
                              {!notification.read && (
                                <span className="badge bg-primary badge-sm">
                                  New
                                </span>
                              )}
                              <span
                                className={`badge bg-${getPriorityColor(
                                  notification.priority
                                )} badge-sm ms-2`}
                              >
                                {notification.priority}
                              </span>
                            </div>
                            <p className="text-muted mb-2">
                              {notification.message}
                            </p>
                            <div className="d-flex align-items-center text-muted small">
                              <span>From: {notification.from}</span>
                              <span className="mx-2">•</span>
                              <span>
                                {new Date(
                                  notification.timestamp
                                ).toLocaleString()}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="dropdown">
                          <button
                            className="btn btn-outline-secondary btn-sm dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-dots-vertical"></i>
                          </button>
                          <ul className="dropdown-menu">
                            {!notification.read && (
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => markAsRead(notification.id)}
                                >
                                  <i className="ti ti-check me-2"></i>Mark as
                                  Read
                                </button>
                              </li>
                            )}
                            <li>
                              <button className="dropdown-item">
                                <i className="ti ti-star me-2"></i>Important
                              </button>
                            </li>
                            <li>
                              <button className="dropdown-item text-danger">
                                <i className="ti ti-trash me-2"></i>Delete
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-4">
                  <div className="avatar avatar-lg bg-light-transparent mb-3">
                    <i className="ti ti-bell-off fs-2 text-muted"></i>
                  </div>
                  <h5 className="text-muted">No notifications</h5>
                  <p className="text-muted">
                    No notifications found for the selected filters.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentNotifications;
